export const styleCardItem = `
flex-grow: 0;
flex-shrink: 0;
flex-basis: 20%;
@media (max-width: 1400px) {
    flex-basis:30%;
  }
  @media (max-width: 1024px) {
    flex-basis: 40%;
  }
  @media (max-width: 600px) {
    flex-basis: 50%;
  }
`
